import React, { useEffect, useState } from 'react';
import './../../Resources/Css/imageAnimations.css'

export const AnimatedImage = (props) => {
    const [image, setImage] = useState("");
    const [alt, setAlt] = useState("");
    const [animation, setAnimation] = useState("quick-zoom");

    useEffect(() => {
        setImage(props.image);
        setAlt(props.alt);
        setAnimation("img-hover-zoom img-hover-zoom--" + props.animation);
    });

    return (
        <div class={animation} >
            <img src={image} alt={alt} className="img-fluid" />
        </div>
    );
}

export const ImageTextOverlay = (props) => {
    const [text, setText] = useState("");
    const [location, setLocation] = useState("");
    const [addClass, setAddClass] = useState(" ");

    useEffect(() => {
        setText(props.text);
        setLocation(props.location);
        setAddClass(props.addClass);
    });

    return (
        <div class={`img-text-overlay img-text-${location} ${addClass} `} >
            {text}
        </div>
    );
}


//Sample

//<Col lg="4" className="about-photo-frame img-text-container">
//    <AnimatedImage image={img_6} animation="brightness" />
//    <ImageTextOverlay location="centered" text={
//        <Fragment>
//            or something sweet!!!
//        </Fragment>
//    } />